import {HeaderTitle} from '../../../../common/HeaderTitle.jsx'
import {SimpleTable} from "../../../../common/simpleTable/SimpleTable.jsx";
import {tableListaKontProfilu} from "../../lib/columns/tableListaKontProfilu.jsx";
import {useKontaPowiazaneProfilu} from "../../../../../api/domain/profile/queries/useKontaPowiazaneProfilu.jsx";
import ButtonWithIcon from "../../../../common/ButtonWithIcon.jsx";
import {Icons} from "../../../../common/Icons.jsx";
import {useSelector} from "react-redux";
import {useEffect, useState} from "react";
import {Input} from "../../../../common/inputs/index.js";
import {usePowiazKontoZProfilem} from "../../../../../api/domain/profile/mutations/usePowiazKontoZProfilem.jsx";
import {useOdlaczKontoOdProfilu} from "../../../../../api/domain/profile/mutations/useOdlaczKontoOdProfilu.jsx";
import {useNavigate, useParams} from "react-router-dom";
import {useUprawnienia} from "../../../../../api/domain/osoby/queries/useUprawnienia.jsx";
import {useProfil} from "../../../../../api/domain/profile/queries/useProfil.jsx";
import {ModalOdlaczKonto, ModalPowiazKonto} from "../../lib/modals.jsx";
import {Col, Row} from "react-bootstrap";

const ViewListaKontProfilu = () => {
    const {profilId: profilIdFromUrl} = useParams()
    const navigate = useNavigate()
    const currentUserId = useSelector((state) => state.user.user?.user_id ?? state.user.user?.id)
    const ownerProfilId = useSelector((state) => state.user.profilId)
    const profilId = ownerProfilId || profilIdFromUrl
    const listaPozycji = useKontaPowiazaneProfilu(profilId)
    const powiazKonto = usePowiazKontoZProfilem()
    const odlaczKonto = useOdlaczKontoOdProfilu()
    const titleName = `Lista kont powiązanych z profilem: ${profilId || ''}`
    const [currPozycja, setCurrPozycja] = useState({})
    const [form, setForm] = useState({id: '', user_email: ''})
    const [modalState, setModalState] = useState({
        delete: false,
        powiaz: false,
    })
    const uprawnienia = useUprawnienia()
    const isOwner = Array.isArray(uprawnienia.data?.perms) && uprawnienia.data.perms.includes('owner')
    const {data: profil} = useProfil(profilId)

    useEffect(() => {
        if (ownerProfilId && profilIdFromUrl && ownerProfilId !== profilIdFromUrl) {
            navigate(`/wp/profile/konta/${ownerProfilId}`, {replace: true})
        }
    }, [navigate, ownerProfilId, profilIdFromUrl])

    const openModal = (type, data = {}) => {
        if (!isOwner) return
        setCurrPozycja(data)
        setModalState((prev) => ({...prev, [type]: true}))
    }

    const closeModal = (type) => {
        if (!isOwner) return
        setModalState((prev) => ({...prev, [type]: false}))
        if (type === 'powiaz') {
            setForm({id: '', user_email: ''})
        }
    }

    const canSubmitPowiazanie =
        !!form?.user_email?.trim() &&
        Number.isInteger(+form?.id) &&
        +form?.id > 0

    const handlePowiaz = async () => {
        if (!canSubmitPowiazanie) return
        await powiazKonto.mutate({
            profil_id: profilId,
            id: +form.id,
            user_email: form.user_email.trim(),
        })
        closeModal('powiaz')
    }

    const handleOdlacz = async () => {
        await odlaczKonto.mutate({
            profilId,
            userId: currPozycja.id,
        })
        closeModal('delete')
    }

    const modals = () => (
        <>
            <ModalOdlaczKonto
                show={modalState.delete}
                handleClose={() => closeModal('delete')}
                currPozycja={currPozycja}
                isPending={odlaczKonto.isPending}
                onConfirm={handleOdlacz}
            />
            <ModalPowiazKonto
                show={modalState.powiaz}
                handleClose={() => closeModal('powiaz')}
                form={form}
                setForm={setForm}
                canSubmitPowiazanie={canSubmitPowiazanie}
                isPending={powiazKonto.isPending}
                onSubmit={handlePowiaz}
            />
        </>
    )
    const th = () => (
        <>
            <th>Akcje</th>
        </>
    )

    const td = (row) => (
        <>
            <td>
                <div className={'d-flex gap-2'}>
                    {isOwner && Number(row.id) !== Number(currentUserId) && (
                        <ButtonWithIcon
                            onClick={() => openModal('delete', row)}
                            variant={'danger'}
                            size={'sm'}
                            icon={<Icons.delete/>}
                            title='Odłącz konto od profilu'
                        />
                    )}
                </div>
            </td>
        </>
    )

    return (
        <>
            {isOwner && Object.values(modalState || {}).some(Boolean) && modals()}
            <HeaderTitle
                breadcrumbLinks={[
                    {label: titleName},
                ]}
                home
                nav
                destination={'/'}
                size={'fs-3'}
                title={titleName}
            />

            <div className={'d-grid gap-2 mb-4'}>
                <label className={"d-flex justify-content-center fw-bold mb-0"} style={{fontSize: '1.2rem'}}>Dane profilu:</label>
                <Row>
                    <Col>
                        <Input
                            disabled={true}
                            label={'Kod instytucji'}
                            value={profil?.id || ''}
                        />
                    </Col>
                    <Col>
                        <Input
                            disabled={true}
                            label={'Nazwa instytucji'}
                            value={profil?.nazwa || ''}
                        />
                    </Col>
                    <Col>
                        {profil?.symbol !== 'D' && (
                            <Input
                                label={'REGON'}
                                value={profil?.identyfikator || ''}
                                disabled={true}
                            />
                        )}
                    </Col>
                </Row>
            </div>

            {isOwner && (
                <>
                    <div className={'d-flex justify-content-end gap-3'}>
                        <ButtonWithIcon
                            size={'lg'}
                            text={'Powiąż konto z profilem'}
                            variant={'primary'}
                            icon={<Icons.addUser/>}
                            title='Powiąż konto z profilem'
                            onClick={() => openModal('powiaz', {profilId})}
                        />
                    </div>
                </>
            )}

            <SimpleTable
                detailKey={`profile_konta_polaczone_${profilId}`}
                columns={tableListaKontProfilu}
                addTh={th}
                addTd={td}
                data={listaPozycji.data || []}
            />
        </>
    )
}

export default ViewListaKontProfilu
